import React, { useEffect, useState } from "react";
import Slider from "react-slick";
import MediaCardLite from "../../molecules/media-card-lite/MediaCardLite";
import MediaCard from "../../molecules/media-card/mediaCard";
import { graphql, navigate, useStaticQuery } from "gatsby";

// Components //
import TitleSection from "../../molecules/title-section";
import NoContentMessage from "../../molecules/no-content-message/noContentMessage";

// Styles //
import "./RecommendedContent.scss";

const RecommendedContent = (props: any) => {

  const contenidoBibliotecas = useStaticQuery(graphql`
    query QUERY_BIBLIOTECAS_Y_EVENTOS {
        bibliotecaPersonas: allContentfulSubcategorias(
          filter: {contentful_id: {eq: "7KHkTe0HcCUf8Xhn7NvwGC"}}
        ) {
          nodes {
            referenciaSubcategorias {
              titulo
              slug
              referenciaSubcategorias {
                slug
                referenciaInterna {
                  referenciaContenido {
                    referenciaMultimedia {
                      tituloMultimedia
                      textoIntroductorio
                      tematica
                      categoriaMultimedia
                      imagenPrincipal {
                        gatsbyImageData(
                            layout: CONSTRAINED
                            outputPixelDensities: [0.5, 1, 2]
                            breakpoints: [320, 768, 1024, 1440]
                            placeholder: BLURRED
                            sizes: "(max-width: 320px) 320px, (max-width: 768px) 768px, (max-width: 1024px) 1024px, 1440px"
                        )
                        description
                      }
                      miniatura {
                        file {
                          url
                        }
                      }
                      tituloBoton
                    }
                  }
                }
              }
            }
          }
        }
        bibliotecaEmpresas: allContentfulSubcategorias(
          filter: {contentful_id: {eq: "375byUYeLcAQQ0m8BX1vLf"}}
        ) {
          nodes {
            referenciaSubcategorias {
              titulo
              slug
              referenciaSubcategorias {
                slug
                referenciaInterna {
                  referenciaContenido {
                    referenciaMultimedia {
                      tituloMultimedia
                      textoIntroductorio
                      tematica
                      categoriaMultimedia
                      imagenPrincipal {
                        gatsbyImageData(
                            layout: CONSTRAINED
                            outputPixelDensities: [0.5, 1, 2]
                            breakpoints: [320, 768, 1024, 1440]
                            placeholder: BLURRED
                            sizes: "(max-width: 320px) 320px, (max-width: 768px) 768px, (max-width: 1024px) 1024px, 1440px"
                        )
                        description
                      }
                      miniatura {
                        file {
                          url
                        }
                      }
                      tituloBoton
                    }
                  }
                }
              }
            }
          }
        }
        teOfrecemosContent: allContentfulPlantillaContenido(
          filter: {contentful_id: {eq: "4lExHPMRcygcPCwg8tdr04"}}
        ) {
          nodes {
            referenciaSubcategoria {
              titulo
              slug
              referenciaInterna {
                referenciaContenido {
                  referenciaMultimedia {
                    tituloMultimedia
                    imagenPrincipal {
                      gatsbyImageData(
                          layout: CONSTRAINED
                          outputPixelDensities: [0.5, 1, 2]
                          breakpoints: [320, 768, 1024, 1440]
                          placeholder: BLURRED
                          sizes: "(max-width: 320px) 320px, (max-width: 768px) 768px, (max-width: 1024px) 1024px, 1440px"
                      )
                      description
                    }
                    miniatura {
                      file {
                        url
                      }
                    }
                    tematica
                    categoriaMultimedia
                    textoIntroductorio
                  }
                }
              }
            }
          }
        }
        eventosEmpresas: allContentfulSubcategorias(
          filter: {contentful_id: {eq: "3lu1VnDLUxgwv9h7HwEJFj"}}
        ) {
          nodes {
            referenciaSubcategorias {
              titulo
              slug
              referenciaInterna {
                referenciaContenido {
                  referenciaEventos {
                    titulo
                    tituloEvento
                    lugarEvento
                    horaEvento
                    fechaEvento
                    tituloBoton
                    imagenPrincipal {
                      gatsbyImageData(
                          layout: CONSTRAINED
                          outputPixelDensities: [0.5, 1, 2]
                          breakpoints: [320, 768, 1024, 1440]
                          placeholder: BLURRED
                          sizes: "(max-width: 320px) 320px, (max-width: 768px) 768px, (max-width: 1024px) 1024px, 1440px"
                      )
                      description
                    }
                    modoEvento
                    tipoEvento
                    requiereInscripcion
                  }
                }
              }
            }
          }
        }
        eventosPersonas: allContentfulSubcategorias(
          filter: {contentful_id: {eq: "2HMk90OWYIyHhaLBbB3JKg"}}
        ) {
          nodes {
            referenciaSubcategorias {
              titulo
              slug
              referenciaInterna {
                referenciaContenido {
                  referenciaEventos {
                    titulo
                    tituloEvento
                    lugarEvento
                    horaEvento
                    fechaEvento
                    tituloBoton
                    imagenPrincipal {
                      gatsbyImageData(
                          layout: CONSTRAINED
                          outputPixelDensities: [0.5, 1, 2]
                          breakpoints: [320, 768, 1024, 1440]
                          placeholder: BLURRED
                          sizes: "(max-width: 320px) 320px, (max-width: 768px) 768px, (max-width: 1024px) 1024px, 1440px"
                      )
                      description
                    }
                    modoEvento
                    tipoEvento
                    requiereInscripcion
                  }
                }
              }
            }
          }
        }
        noContentPersonas: contentfulPlantillaContenido(contentful_id: {eq: "2dt9lXNqjZbN2k5Tkcxk6X"}) {
          tituloBanner
          descripcion {
              raw
          }
          imagenPrincipal 
          {
              gatsbyImageData(
                  layout: CONSTRAINED
                  outputPixelDensities: [0.5, 1, 2]
                  breakpoints: [320, 768, 1024, 1440]
                  placeholder: BLURRED
                  sizes: "(max-width: 320px) 320px, (max-width: 768px) 768px, (max-width: 1024px) 1024px, 1440px"
              )
              description
          }
        }
        noContentEmpresas: contentfulPlantillaContenido(contentful_id: {eq: "BC75RgxlmLYMaMURxeNNn"}) {
            tituloBanner
            descripcion {
                raw
            }
            imagenPrincipal 
            {
                gatsbyImageData(
                    layout: CONSTRAINED
                    outputPixelDensities: [0.5, 1, 2]
                    breakpoints: [320, 768, 1024, 1440]
                    placeholder: BLURRED
                    sizes: "(max-width: 320px) 320px, (max-width: 768px) 768px, (max-width: 1024px) 1024px, 1440px"
                )
                description
            }
        }
      }
`);

  const eventosEmpresasData = contenidoBibliotecas.eventosEmpresas.nodes[0].referenciaSubcategorias
  const eventosPersonasData = contenidoBibliotecas.eventosPersonas.nodes[0].referenciaSubcategorias
  const empresasData = contenidoBibliotecas.bibliotecaEmpresas.nodes[0].referenciaSubcategorias
  const personasData = contenidoBibliotecas.bibliotecaPersonas.nodes[0].referenciaSubcategorias
  const teOfrecemosContent = contenidoBibliotecas.teOfrecemosContent.nodes[0].referenciaSubcategoria

  const [masDeEmpleoContent, setMasDeEmpleoContent] = useState<any[]>([]);
  const [sliderNovedades, setSliderNovedades] = useState<Slider | null>(null);
  const [novedadesContent, setNovedadesContent] = useState<any[]>([]);
  const [personasContent, setPersonasContent] = useState([]);
  const [empresasContent, setEmpresasContent] = useState([]);
  const [interesContent, setInteresContent] = useState<any[][]>([]);
  const [indexNovedades, setIndexNovedades] = useState(0);
  const [sliderIndex, setSliderIndex] = useState(0);
  const [loaded, setLoaded] = useState(false);
  const [slider, setSlider] = useState<Slider | null>(null);

  // Configuracion para el slider De tu interes
  const interesCarousel = {
    className: 'slider-interes',
    customPaging: i => (
      <div className={`line line-${i}`}>──</div>
    ),
    dots: true,
    infinite: false,
    speed: 300,
    slidesToShow: 2,
    arrows: false,
    slidesToScroll: 1,
    waitForAnimate: false,
    autoplay: false,
    fade: false,
    autoplaySpeed: 10000,
    variableWidth: true,
    beforeChange: (_: number, next: number) => {
      setSliderIndex(next);
    }
  };

  // Configuracion para el slider de Novedades
  const novedadesCarousel = {
    className: 'slider-novedades',
    customPaging: i => (
      <div className={`line line-${i}`}>──</div>
    ),
    dots: true,
    infinite: false,
    speed: 300,
    slidesToShow: 1,
    arrows: false,
    slidesToScroll: 1,
    waitForAnimate: false,
    autoplay: false,
    fade: false,
    autoplaySpeed: 10000,
    variableWidth: true,
    beforeChange: (_: number, next: number) => {
      setIndexNovedades(next);
    }
  };

  // Control del index para el slider Interes
  const goToNext = () => {
    if (slider && Array.isArray(slider.props.children) && sliderIndex < slider.props.children.length - 1) {
      setSliderIndex(sliderIndex + 1);
      slider.slickNext();
    }
  };

  const goToBack = () => {
    if (sliderIndex > 0) {
      setSliderIndex(sliderIndex - 1);
      slider?.slickPrev();
    }
  };

  const isActiveBack = () => sliderIndex > 0;
  const isActiveNext = () => slider && Array.isArray(slider.props.children) && sliderIndex < slider.props.children.length - 1;

  // Control del index para el slider de Novedades
  const goToNextN = () => {
    if (sliderNovedades && Array.isArray(sliderNovedades.props.children) && indexNovedades < sliderNovedades.props.children.length - 1) {
      setIndexNovedades(indexNovedades + 1);
      sliderNovedades.slickNext();
    }
  };

  const goToBackN = () => {
    if (indexNovedades > 0) {
      setIndexNovedades(indexNovedades - 1);
      sliderNovedades?.slickPrev();
    }
  };

  const isActiveBackN = () => indexNovedades > 0;
  const isActiveNextN = () => Array.isArray(sliderNovedades?.props.children) && indexNovedades < sliderNovedades.props.children.length - 1;

  // Funcion para generar un numero aleatorio entre 0 y maxNumber
  const randomNumber = (maxNumber: number) => {
    return Math.floor(Math.random() * maxNumber);
  }

  const setRandomArticle = (library, setLibrary) => {
    // Selecciona una categoria aleatoria de las bibliotecas excepto Mas de Empleo
    const category = library[randomNumber(4)]
    // Selecciona un articulo aleatorio de la categoria aleatoria
    const articleSubcategory = category.referenciaSubcategorias[randomNumber(category.referenciaSubcategorias.length)]
    const articleSlug = articleSubcategory.referenciaInterna.referenciaContenido[0].referenciaMultimedia[0]

    // Slug para la redireccion del boton
    const libraryType = category.titulo.includes("Empresas") ? "empresas/biblioteca/" : "personas/biblioteca/"
    articleSlug["redireccionBoton"] = libraryType + category.slug + articleSubcategory.slug
    setLibrary(prevContent => [...prevContent, articleSubcategory.referenciaInterna.referenciaContenido[0].referenciaMultimedia[0]])
  }

  const setRandomEvent = (eventosData) => {
    if (eventosData && eventosData != null) {
      const randomEventSubcategory = eventosData[randomNumber(eventosData.length)]
      const randomEvent = randomEventSubcategory.referenciaInterna.referenciaContenido[0].referenciaEventos[0]
      const eventType = randomEventSubcategory.titulo.includes("Empresas >") ? "empresas/eventos/" : "personas/eventos/"
      randomEvent["redireccionBoton"] = eventType + randomEventSubcategory.slug
      setNovedadesContent(prevState => [...prevState, randomEvent]);
    } else {
      setNovedadesContent(prevState => [...prevState, null]);
    }
  }

  const createSlug = (category) => {
    const randomArticleSubcategory = category.referenciaSubcategorias[randomNumber(category.referenciaSubcategorias.length)]
    const libraryType = category.titulo.includes("Empresas >") ? "empresas/biblioteca/" : "personas/biblioteca/"
    const slug = libraryType + category.slug + randomArticleSubcategory.slug
    randomArticleSubcategory.referenciaInterna.referenciaContenido[0].referenciaMultimedia[0]['redireccionBoton'] = slug
    setNovedadesContent(prevState => [...prevState, randomArticleSubcategory.referenciaInterna.referenciaContenido[0].referenciaMultimedia[0]])
  }


  const addNovedadesContent = () => {
    setRandomEvent(eventosEmpresasData)

    let iniciativasEmpleoArticle = empresasData[6]
    createSlug(iniciativasEmpleoArticle)

    setRandomEvent(eventosPersonasData)

    iniciativasEmpleoArticle = personasData[6]
    createSlug(iniciativasEmpleoArticle)
  }

  // Contenido para los bloques
  useEffect(() => {
    // Contenido para el bloque 1 de slider 'De tu interes'
    for (let index = 0; index < 2; index++) {
      setRandomArticle(empresasData, setEmpresasContent)
      setRandomArticle(personasData, setPersonasContent)
    }

    // Contenido para el bloque 2 de slider 'Novedades'
    addNovedadesContent()

    // Contenido para el bloque 3 de slider 'Mas de empleo'
    for (const articule of teOfrecemosContent) {
      const slug = articule.titulo.includes("Empresas >") ? 'empresas/biblioteca/mas-de-empleo/' : 'personas/biblioteca/mas-de-empleo/'
      articule.referenciaInterna.referenciaContenido[0].referenciaMultimedia[0]['redireccionBoton'] = slug + articule.slug
      setMasDeEmpleoContent(prevState => [...prevState, articule.referenciaInterna.referenciaContenido[0].referenciaMultimedia[0]])
    }
  }, [])

  // Contenido para el bloque 1 de slider 'De tu interes'
  useEffect(() => {

    if (personasContent && empresasContent)
      setInteresContent([personasContent, empresasContent])

    if (empresasContent.length > 1 && masDeEmpleoContent.length > 1 && interesContent.length > 1)
      setLoaded(true)
  }, [empresasContent, personasContent])

  return (
    <div className="o-recommended-content">
      <TitleSection title={"Destacados de tu interés"} />

      <div className="o-recommended-content-section">
        <div className="o-recommended-content-section-interes">
          <h3 className="o-recommended-content-section-interes-title">
            Publicaciones <br /> recientes
          </h3>
          <>
            <div className={`o-recommended-content-section-interes-card`}>
              <div className="o-recommended-content-section-interes-card-arrows-slider">
                <span
                  className={`arrow icon-chevron-left ${isActiveBack() ? "active" : ""
                      } gtm_navegar_recientes_atras_general`}
                  onClick={goToBack}
                ></span>
                <span
                  className={`arrow  icon-chevron-right  ${isActiveNext() ? "active" : ""
                      } gtm_navegar_recientes_adelante_general`}
                  onClick={goToNext}
                ></span>
              </div>
              <Slider ref={(c) => { setSlider(c); }}{...interesCarousel}>
                {loaded && interesContent.map((cards) => (
                  cards.map((item, i) => (
                    <>
                      <MediaCard
                        key={i}
                        tituloMultimedia={item.tituloMultimedia}
                        descripcion={{
                          json: undefined
                        }}
                        imagenPrincipal={
                          item.imagenPrincipal    
                        }
                        tituloBoton='VER MÁS'
                        redireccionBoton={item.redireccionBoton}
                        slug={item.redireccionBoton}
                        tematica={item.tematica}
                        categoriaMultimedia={item.categoriaMultimedia}
                        nuevoContenido={false} />
                    </>
                  ))))}
              </Slider>
            </div>
          </>
        </div>

        <div className="o-recommended-content-section-novedades">
          <h3 className="o-recommended-content-section-novedades-title">
            Novedades
          </h3>
          <div className="o-recommended-content-section-novedades-card-arrows-slider">
            <span
              className={`arrow icon-chevron-left ${isActiveBackN() ? "active" : ""
                  } gtm_navegar_novedades_atras_general`}
              onClick={goToBackN}
            ></span>
            <span
              className={`arrow  icon-chevron-right  ${isActiveNextN() ? "active" : ""
                  } gtm_navegar_novedades_adelante_general`}
              onClick={goToNextN}
            ></span>
          </div>
          <Slider ref={(c) => { setSliderNovedades(c); }}{...novedadesCarousel}>
            {loaded && novedadesContent.map((item: any, i) => {
              if(item == null && i == 0) {
                return <NoContentMessage key={i} title={contenidoBibliotecas.noContentEmpresas.tituloBanner} subtitle={contenidoBibliotecas.noContentEmpresas.descripcion} imagenPrincipal={contenidoBibliotecas.noContentEmpresas.imagenPrincipal} className="evento-empresas"/>
              }
              if (item == null && i == 2) {
                return <NoContentMessage key={i} title={contenidoBibliotecas.noContentPersonas.tituloBanner} subtitle={contenidoBibliotecas.noContentPersonas.descripcion} imagenPrincipal={contenidoBibliotecas.noContentPersonas.imagenPrincipal} className="evento-personas"/>
              }
              return <MediaCard
                key={i}
                tituloMultimedia={item.tituloMultimedia || item.tituloEvento}
                textoIntroductorio={item.textoIntroductorio}
                descripcion={{
                  json: undefined
                }}
                imagenPrincipal={
                  item.imagenPrincipal    
                }
                tituloBoton={item.requiereInscripcion ? 'INSCRÍBETE AQUÍ' : 'CONOCE MÁS AQUÍ'}
                redireccionBoton={item.redireccionBoton}
                slug={item.redireccionBoton}
                tematica={item.tematica}
                categoriaMultimedia={item.categoriaMultimedia || item.tipoEvento}
                tituloEvento={item.tituloEvento}
                fechaEvento={item.fechaEvento?.split(',')[2] + ', ' + item.fechaEvento?.split(',')[0] + ' de ' + item.fechaEvento?.split(',')[1]}
                horaEvento={item.horaEvento}
                lugarEvento={item.lugarEvento}
                nuevoContenido={false}
              />
            })}
          </Slider>
        </div>

        <div className="o-recommended-content-section-ofrecemos">
          <h3 className="o-recommended-content-section-ofrecemos-title">
            Te ofrecemos
          </h3>
          {loaded && masDeEmpleoContent.map((item, i) => (
            <>
              <MediaCardLite
                key={i}
                tituloMultimedia={item.tituloMultimedia}
                textoIntroductorio={""}
                descripcion={{
                  json: undefined,
                }}
                imagenPrincipal={
                  item.imagenPrincipal    
                }
                tituloBoton='VER MÁS'
                tematica={item.tematica}
                categoriaMultimedia={item.categoriaMultimedia}
                nuevoContenido={false}
                onClick={() => { navigate(item.redireccionBoton) }}
              />
            </>
          ))}
        </div>
      </div>
    </div >
  );
};

export default RecommendedContent;
